(function () {
  const KLAVIYO_PATTERN = /klaviyo|sign me up|no thanks/i;
  const COOKIE_PATTERN = /cookie|cookies|consent|datenschutz|einwilligung|zustimmung|akzeptieren|ablehnen/i;
  const COOKIE_ROOT_SELECTOR = '#shopify-pc__banner, [id*="shopify-pc"], [class*="shopify-pc"]';
  let scheduled = false;
  let lastTextRepairAt = 0;
  let profiStatusPromise = null;
  let profiStatusCache = null;
  let profiStatusCacheKey = "";
  let profiStatusCacheAt = 0;

  function textOf(node) {
    return (node && node.textContent ? node.textContent : "").replace(/\s+/g, " ").trim();
  }

  function isVisible(el) {
    if (!el || !(el instanceof HTMLElement)) return false;
    const style = window.getComputedStyle(el);
    const rect = el.getBoundingClientRect();
    return style.display !== "none" && style.visibility !== "hidden" && rect.width > 20 && rect.height > 20;
  }

  function isOverlayCandidate(el) {
    const style = window.getComputedStyle(el);
    const rect = el.getBoundingClientRect();
    const zIndex = Number.parseInt(style.zIndex || "0", 10);
    const role = (el.getAttribute("role") || "").toLowerCase();
    const modal = el.getAttribute("aria-modal") === "true";
    const shopifyPrivacy = /shopify-pc/i.test(`${el.id || ""} ${el.className || ""}`);
    const fixedLayer = style.position === "fixed" || style.position === "sticky";
    return shopifyPrivacy && (modal || role === "dialog" || fixedLayer || zIndex > 50 || rect.height > 80);
  }

  function looksLikeKlaviyo(el) {
    const haystack = `${el.id || ""} ${el.className || ""} ${textOf(el)}`;
    return KLAVIYO_PATTERN.test(haystack);
  }

  function looksLikeCookie(el) {
    const haystack = `${el.id || ""} ${el.className || ""} ${textOf(el)}`;
    return COOKIE_PATTERN.test(haystack);
  }

  function setImportantStyle(el, property, value) {
    if (!el || !(el instanceof HTMLElement)) return;
    if (el.style.getPropertyValue(property) === value) return;
    el.style.setProperty(property, value, "important");
  }

  function fitCookieBanner() {
    const banner = document.getElementById("shopify-pc__banner");
    if (!isVisible(banner)) return;

    const isMobile = window.matchMedia("(max-width: 749px)").matches;
    setImportantStyle(banner, "box-sizing", "border-box");
    setImportantStyle(banner, "height", "auto");
    setImportantStyle(banner, "border-radius", "14px");
    setImportantStyle(banner, "overflow", "hidden");
    setImportantStyle(banner, "bottom", isMobile ? "8px" : "16px");
    setImportantStyle(banner, "left", isMobile ? "8px" : "50%");
    setImportantStyle(banner, "right", isMobile ? "8px" : "auto");
    setImportantStyle(banner, "width", isMobile ? "auto" : "min(720px, calc(100vw - 32px))");
    setImportantStyle(banner, "max-width", isMobile ? "none" : "min(720px, calc(100vw - 32px))");
    setImportantStyle(
      banner,
      "max-height",
      isMobile ? "min(360px, calc(100vh - 16px))" : "min(420px, calc(100vh - 32px))",
    );
    setImportantStyle(banner, "transform", isMobile ? "none" : "translateX(-50%)");

    const wrapper = banner.querySelector(".shopify-pc__banner__wrapper");
    setImportantStyle(wrapper, "box-sizing", "border-box");
    setImportantStyle(wrapper, "display", "flex");
    setImportantStyle(wrapper, "flex-direction", "column");
    setImportantStyle(wrapper, "width", "auto");
    setImportantStyle(wrapper, "overflow", "hidden");
    setImportantStyle(
      wrapper,
      "max-height",
      isMobile ? "min(344px, calc(100vh - 32px))" : "min(420px, calc(100vh - 32px))",
    );
    setImportantStyle(wrapper, "padding", isMobile ? "10px 10px 12px" : "18px 20px 20px");

    const body = banner.querySelector(".shopify-pc__banner__body");
    setImportantStyle(body, "max-height", isMobile ? "96px" : "148px");
    setImportantStyle(body, "overflow", "auto");
    setImportantStyle(body, "padding-right", "4px");

    const title = banner.querySelector("#shopify-pc__banner__body-title");
    if (isMobile) {
      setImportantStyle(title, "font-size", "13px");
      setImportantStyle(title, "line-height", "1.2");
      setImportantStyle(title, "margin-bottom", "4px");
    }

    const buttonGroup = banner.querySelector(".shopify-pc__banner__btns");
    setImportantStyle(buttonGroup, "display", "grid");
    setImportantStyle(buttonGroup, "grid-template-columns", isMobile ? "1fr 1fr" : "repeat(3, minmax(0, 1fr))");
    setImportantStyle(buttonGroup, "gap", "8px");
    setImportantStyle(buttonGroup, "margin-top", isMobile ? "8px" : "10px");
    setImportantStyle(buttonGroup, "flex", "0 0 auto");

    const manageButton = banner.querySelector("#shopify-pc__banner__btn-manage-prefs");
    setImportantStyle(manageButton, "grid-column", isMobile ? "1 / -1" : "auto");

    banner.querySelectorAll(".shopify-pc__banner__btns button").forEach((button) => {
      setImportantStyle(button, "min-height", isMobile ? "32px" : "40px");
      setImportantStyle(button, "height", isMobile ? "32px" : "40px");
      setImportantStyle(button, "padding", isMobile ? "0 10px" : "0 14px");
      setImportantStyle(button, "font-size", isMobile ? "12px" : "13px");
      setImportantStyle(button, "line-height", "1");
      setImportantStyle(button, "white-space", "nowrap");
    });
  }

  function classifyDialogs() {
    document.body.classList.toggle("dk-preview-bar-visible", Boolean(document.getElementById("PBarNextFrame")));
    document.body.classList.toggle(
      "dk-product-page",
      window.location.pathname.indexOf("/products/") === 0,
    );
    document.body.classList.toggle(
      "dk-pro-registration-page",
      window.location.pathname.indexOf("/pages/als-friseur-registrieren") === 0,
    );

    const candidates = Array.from(
      document.querySelectorAll(`${COOKIE_ROOT_SELECTOR}, .klaviyo-form, [class*="klaviyo"], [id*="klaviyo"]`),
    ).filter((el) => isVisible(el) && (isOverlayCandidate(el) || looksLikeKlaviyo(el)));

    const cookieRoots = new Set();
    for (const el of candidates) {
      if (!looksLikeCookie(el) || looksLikeKlaviyo(el)) continue;
      const root = el.closest("#shopify-pc__banner") || el.closest('[id*="shopify-pc"], [class*="shopify-pc"]') || el;
      if (root instanceof HTMLElement && isVisible(root)) cookieRoots.add(root);
    }

    document.querySelectorAll(".dk-cookie-consent-panel").forEach((el) => {
      if (!cookieRoots.has(el)) el.classList.remove("dk-cookie-consent-panel");
    });
    cookieRoots.forEach((el) => el.classList.add("dk-cookie-consent-panel"));

    const cookieVisible = cookieRoots.size > 0;
    document.body.classList.toggle("dk-cookie-layer-visible", cookieVisible);
    fitCookieBanner();

    if (!cookieVisible) {
      document.querySelectorAll('[data-dk-deferred="true"]').forEach((el) => {
        el.removeAttribute("data-dk-deferred");
        el.style.removeProperty("display");
      });
      updateStickyAtc();
      return;
    }

    for (const el of candidates) {
      if (looksLikeKlaviyo(el)) {
        el.setAttribute("data-dk-deferred", "true");
        el.style.setProperty("display", "none", "important");
      }
    }
    updateStickyAtc();
  }

  function ensureStickyAtc() {
    let sticky = document.querySelector(".dk-sticky-atc");
    if (!sticky) {
      sticky = document.createElement("div");
      sticky.className = "dk-sticky-atc";
      sticky.innerHTML = '<button type="button" class="dk-sticky-atc__button"></button><div class="dk-sticky-atc__status" role="status" aria-live="polite" hidden></div>';
      document.body.appendChild(sticky);
      sticky.querySelector("button").addEventListener("click", () => {
        const submit = getMainProductSubmit();
        if (submit && !submit.disabled) submit.click();
        const status = sticky.querySelector(".dk-sticky-atc__status");
        if (status) {
          status.hidden = false;
          status.textContent = "Wird in den Warenkorb gelegt...";
          window.setTimeout(() => {
            status.textContent = "Warenkorb aktualisiert.";
          }, 1400);
          window.setTimeout(() => {
            status.hidden = true;
            status.textContent = "";
          }, 3600);
        }
      });
    }
    return sticky;
  }

  function getMainProductSubmit() {
    if (window.location.pathname.indexOf("/products/") !== 0) return null;

    const productRoot =
      document.querySelector('main [id*="MainProduct"], main .product') ||
      document.querySelector('[id*="MainProduct"], .product');
    const formRoot = productRoot || document.querySelector("main") || document;
    const forms = Array.from(formRoot.querySelectorAll('form[action*="/cart/add"]'));
    const form =
      forms.find((candidate) => candidate.getAttribute("data-type") === "add-to-cart-form" && candidate.querySelector('button[type="submit"], button[name="add"]')) ||
      forms.find((candidate) => candidate.querySelector('button[type="submit"], button[name="add"]'));
    if (!form) return null;

    return form.querySelector('button[type="submit"], button[name="add"]');
  }

  function getSubmitLabel(submit) {
    if (!submit) return "In den Warenkorb legen";

    const visibleTextNodes = Array.from(submit.querySelectorAll("span, div"))
      .filter((node) => {
        const style = window.getComputedStyle(node);
        return !node.classList.contains("hidden") && style.display !== "none" && style.visibility !== "hidden";
      })
      .map((node) => (node.innerText || node.textContent || "").replace(/\s+/g, " ").trim())
      .filter(Boolean);

    const visibleLabel = visibleTextNodes[0] || (submit.innerText || submit.textContent || "").replace(/\s+/g, " ").trim();
    const soldOutText = (window.Shopify?.translations?.soldOut || "Ausverkauft").trim();

    if (submit.disabled || /ausverkauft|sold out/i.test(visibleLabel)) return soldOutText;
    if (/in den warenkorb|add to cart/i.test(visibleLabel)) return "In den Warenkorb legen";

    return visibleLabel || "In den Warenkorb legen";
  }

  function updateStickyAtc() {
    const productPage = document.body.classList.contains("dk-product-page") || window.location.pathname.indexOf("/products/") === 0;
    const submit = getMainProductSubmit();
    const sticky = ensureStickyAtc();
    if (!productPage || !submit) {
      sticky.style.display = "none";
      document.body.classList.remove("dk-sticky-atc-ready");
      return;
    }

    const button = sticky.querySelector("button");
    const isUnavailable = Boolean(submit.disabled);
    button.textContent = getSubmitLabel(submit);
    button.disabled = isUnavailable;
    button.classList.toggle("is-sold-out", isUnavailable);

    const cookie = Array.from(document.querySelectorAll(".dk-cookie-consent-panel, #shopify-pc__banner")).find((el) => {
      const rect = el.getBoundingClientRect();
      const style = window.getComputedStyle(el);
      return style.display !== "none" && style.visibility !== "hidden" && rect.width > 20 && rect.height > 20;
    });
    const cookieRect = cookie ? cookie.getBoundingClientRect() : null;
    const previewOffset = document.body.classList.contains("dk-preview-bar-visible") ? 64 : 0;
    const bottom = cookieRect && cookieRect.height > 20 ? window.innerHeight - cookieRect.top + 8 : previewOffset + 8;
    sticky.style.bottom = `${Math.max(8, Math.round(bottom))}px`;
    sticky.style.display = "";

    const submitRect = submit.getBoundingClientRect();
    const infoContainer = document.querySelector(".product__info-container");
    const infoRect = infoContainer ? infoContainer.getBoundingClientRect() : null;
    const stickyHeight = sticky.getBoundingClientRect().height || 68;
    const viewportSpaceAboveSticky = window.innerHeight - Math.max(8, Math.round(bottom)) - stickyHeight - 12;
    const enoughSpace = viewportSpaceAboveSticky > 280;
    const realButtonOutOfView = submitRect.bottom < 0;
    const realButtonCoveredByCookie =
      cookieRect && submitRect.bottom > cookieRect.top - 6 && submitRect.top < cookieRect.bottom;
    const realButtonUnavailable = !isUnavailable && (realButtonOutOfView || realButtonCoveredByCookie);
    const productInfoStarted = !infoRect || infoRect.top < window.innerHeight * 0.58;
    document.body.classList.toggle("dk-main-atc-covered-by-cookie", Boolean(realButtonCoveredByCookie));
    document.body.classList.toggle("dk-sticky-atc-ready", Boolean(enoughSpace && realButtonUnavailable && productInfoStarted));
  }

  function getProductGalleryWrappers() {
    return Array.from(document.querySelectorAll(".product__media-wrapper")).filter(
      (wrapper) => wrapper instanceof HTMLElement,
    );
  }

  function getPrimaryProductGalleryWrapper() {
    const wrappers = getProductGalleryWrappers();
    if (!wrappers.length) return null;

    const mainProduct =
      document.querySelector('main [id*="MainProduct"], main .product') ||
      document.querySelector('[id*="MainProduct"], .product');
    return wrappers.find((wrapper) => mainProduct && mainProduct.contains(wrapper)) || wrappers.find(isVisible) || wrappers[0];
  }

  function updateProductGallerySticky() {
    const wrappers = getProductGalleryWrappers();
    if (!wrappers.length) return;

    const productPage = window.location.pathname.indexOf("/products/") === 0;
    const desktop = window.matchMedia("(min-width: 990px)").matches;
    const primary = getPrimaryProductGalleryWrapper();

    for (const wrapper of wrappers) {
      if (!productPage || !desktop || wrapper !== primary) {
        wrapper.classList.remove("dk-gallery-sticky-ready");
      }
    }

    if (!productPage || !desktop || !primary) return;

    const thumbnailRail = primary.querySelector(".thumbnail-slider, .thumbnail-list");
    let activationScroll = 0;
    if (thumbnailRail && isVisible(thumbnailRail)) {
      const rect = thumbnailRail.getBoundingClientRect();
      activationScroll = Math.max(0, Math.round(rect.bottom + window.scrollY - window.innerHeight + 24));
    }

    primary.classList.toggle("dk-gallery-sticky-ready", window.scrollY >= activationScroll);
  }

  function repairGermanPopupCopy() {
    const now = Date.now();
    if (now - lastTextRepairAt < 1200) return;
    lastTextRepairAt = now;

    const roots = [
      document.querySelector("header"),
      document.querySelector("#MainContent"),
      ...document.querySelectorAll(".klaviyo-form, [class*='klaviyo'], [id*='klaviyo'], #shopify-pc__banner"),
    ].filter(Boolean);

    const replacements = [
      [/Haar\s+Pflege/gi, "Haarpflege"],
      [/Complete form below to signup for Shopify account\./gi, "Fülle das Formular aus, damit wir deinen Profi-Zugang prüfen können."],
      [/Create an account/gi, "Profi-Konto erstellen"],
      [/Confirm password/gi, "Passwort bestätigen"],
      [/Enter your password/gi, "Passwort eingeben"],
      [/Confirm your password/gi, "Passwort bestätigen"],
      [/First Name/gi, "Vorname"],
      [/Last Name/gi, "Nachname"],
      [/\bEmail\b/gi, "E-Mail"],
      [/\bPassword\b/gi, "Passwort"],
      [/\bSubmit\b/gi, "Anfrage absenden"],
      [/Gewerbe\s+Nachwei(?:s|ß)\s+als\s+Friseur/gi, "Gewerbenachweis als Friseur"],
      [/Gewerbe Nachweis als Friseur/gi, "Gewerbenachweis als Friseur"],
      [/sign me up!?/gi, "Rabatt sichern"],
      [/no,?\s*thanks/gi, "Nein danke"],
      [/Close\s+dialog/gi, "Dialog schließen"],
    ];

    for (const root of roots) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        let value = walker.currentNode.nodeValue;
        let next = value;
        for (const [pattern, replacement] of replacements) {
          next = next.replace(pattern, replacement);
        }
        if (next !== value) walker.currentNode.nodeValue = next;
      }
    }

    document.querySelectorAll(".samitaWS-container input, .samitaWS-container textarea").forEach((el) => {
      const placeholder = el.getAttribute("placeholder");
      if (!placeholder) return;
      let next = placeholder;
      for (const [pattern, replacement] of replacements) {
        next = next.replace(pattern, replacement);
      }
      if (next !== placeholder) el.setAttribute("placeholder", next);
    });

    document.querySelectorAll(".samitaWS-container [data-label]").forEach((el) => {
      const label = el.getAttribute("data-label");
      if (!label) return;
      let next = label;
      for (const [pattern, replacement] of replacements) {
        next = next.replace(pattern, replacement);
      }
      if (next !== label) el.setAttribute("data-label", next);
    });
  }

  function repairHomepageShowcase() {
    const categoryGrid = document.querySelector(".dk-home-showcase__categories");
    if (!categoryGrid) return;

    const cards = Array.from(categoryGrid.querySelectorAll(".dk-home-category"));
    for (const card of cards) {
      const title = textOf(card.querySelector(".dk-home-category__title")).normalize("NFC").toLowerCase();
      if (title.indexOf("parfüm") !== -1 || title.indexOf("parfum") !== -1) {
        card.classList.add("dk-home-category--perfume");
      }
      if (title.indexOf("marken") !== -1) {
        card.classList.add("dk-home-category--brand");
        const media = card.querySelector(".dk-home-category__media");
        if (media && !media.querySelector(".dk-home-category__brand-marks")) {
          media.innerHTML = [
            '<span class="dk-home-category__brand-marks">',
            "<span>Wella</span>",
            "<span>Evelon</span>",
            "<span>Lattafa</span>",
            "<span>Black</span>",
            "</span>",
          ].join("");
        }
      }
    }

    const showcase = categoryGrid.closest(".dk-home-showcase__inner");
    if (showcase && !showcase.querySelector(".dk-home-fragrance")) {
      const fragrance = document.createElement("div");
      fragrance.className = "dk-home-fragrance";
      fragrance.setAttribute("aria-label", "Parfüm und Duftsortiment");
      fragrance.innerHTML = [
        "<div>",
        '<span class="dk-home-fragrance__kicker">Duft & Beauty</span>',
        "<h3>Parfüm als elegantes Zusatzsortiment.</h3>",
        "</div>",
        "<p>Ausgewählte Düfte ergänzen das Kernsortiment, ohne die Friseurbedarf-Struktur zu verwässern. Ideal für Geschenkideen, Beauty-Kunden und Zusatzverkäufe.</p>",
        '<a class="dk-home-fragrance__button" href="/collections/parfum">Parfüm ansehen</a>',
      ].join("");
      categoryGrid.insertAdjacentElement("afterend", fragrance);
    }
  }

  function orderHomepageSections() {
    if (!document.body.classList.contains("dk-index-page")) return;

    const hairAnalysis = document.querySelector('[id$="__dk_hair_analysis"]');
    const showcase = document.querySelector('[id$="__dk_home_showcase"]');
    const bestseller = document.querySelector('[id*="__99a8105b-0068-4986-bb78-1be9b5381f1b"]');
    const shopPaths = document.querySelector('[id$="__dk_home_shop_paths"]');
    if (!hairAnalysis || !showcase || !bestseller || !shopPaths) return;

    const parent = hairAnalysis.parentElement;
    if (!parent || showcase.parentElement !== parent || bestseller.parentElement !== parent || shopPaths.parentElement !== parent) {
      return;
    }

    let anchor = hairAnalysis;
    for (const section of [showcase, bestseller, shopPaths]) {
      if (section.previousElementSibling !== anchor) {
        anchor.insertAdjacentElement("afterend", section);
      }
      anchor = section;
    }
  }

  function getProfiPriceBlocks() {
    return Array.from(document.querySelectorAll("[data-drkalla-profi-price]")).filter(
      (el) => el instanceof HTMLElement,
    );
  }

  function getProfiProductIds(blocks) {
    return Array.from(
      new Set(
        blocks
          .map((block) => block.getAttribute("data-profi-product-id"))
          .filter((value) => value && /^\d+$/.test(value)),
      ),
    );
  }

  function getProfiVariantIds(blocks) {
    return Array.from(
      new Set(
        blocks
          .map((block) => block.getAttribute("data-profi-variant-id"))
          .filter((value) => value && /^\d+$/.test(value)),
      ),
    );
  }

  function fetchProfiStatus(force, productIds, variantIds) {
    const now = Date.now();
    const productKey = (productIds || []).slice().sort().join(",");
    const variantKey = (variantIds || []).slice().sort().join(",");
    const key = `${productKey}|${variantKey}`;
    if (!force && profiStatusCache && profiStatusCacheKey === key && now - profiStatusCacheAt < 45000) {
      return Promise.resolve(profiStatusCache);
    }
    if (!force && profiStatusPromise) return profiStatusPromise;

    const statusUrl = new URL("/apps/drkalla-profi/status", window.location.origin);
    if (productKey) statusUrl.searchParams.set("product_ids", productKey);
    if (variantKey) statusUrl.searchParams.set("variant_ids", variantKey);

    profiStatusPromise = fetch(statusUrl.toString(), {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((status) => {
        profiStatusCache = status || { authenticated: false, profi: false, enabled: false };
        profiStatusCacheKey = key;
        profiStatusCacheAt = Date.now();
        return profiStatusCache;
      })
      .catch(() => {
        profiStatusCache = { authenticated: false, profi: false, enabled: false };
        profiStatusCacheKey = key;
        profiStatusCacheAt = Date.now();
        return profiStatusCache;
      })
      .finally(() => {
        profiStatusPromise = null;
      });

    return profiStatusPromise;
  }

  function applyProfiStatus(status) {
    const blocks = getProfiPriceBlocks();
    if (!blocks.length) return;

    const active = Boolean(status && status.enabled && status.profi);
    const productIdsWithPrice = new Set((status?.profiProductIds || []).map(String));
    const variantIdsWithPrice = new Set((status?.profiVariantIds || []).map(String));
    const pricesByProductId = status?.profiPricesByProductId || {};
    const pricesByVariantId = status?.profiPricesByVariantId || {};
    document.body.classList.toggle("dk-profi-customer", active);

    for (const block of blocks) {
      const liquidActive = block.getAttribute("data-profi-liquid-active") === "true";
      const productId = block.getAttribute("data-profi-product-id");
      const variantId = block.getAttribute("data-profi-variant-id");
      const serverHasPrice = productId && productIdsWithPrice.has(productId);
      const serverVariantHasPrice = variantId && variantIdsWithPrice.has(variantId);
      const shouldShow = liquidActive || (active && (serverVariantHasPrice || serverHasPrice));
      block.hidden = true;
      block.classList.toggle("is-profi-active", shouldShow);
      if (!shouldShow) {
        block.remove();
        continue;
      }

      const serverPrice =
        (variantId ? formatCents(pricesByVariantId[variantId]) : "") ||
        (productId ? formatCents(pricesByProductId[productId]) : "");
      const price = serverPrice || block.getAttribute("data-profi-price-html");
      replaceVisiblePrice(block, price);
    }
  }

  function replaceVisiblePrice(sourceBlock, priceHtml) {
    if (!priceHtml) return;

    const priceRoot = sourceBlock.closest(".price");
    if (!priceRoot) return;

    priceRoot.classList.add("price--drkalla-profi");
    priceRoot.classList.remove("price--on-sale", "price--no-compare");
    priceRoot.querySelectorAll(".price__sale s, .price__badge-sale").forEach((el) => {
      el.setAttribute("hidden", "");
    });

    const target =
      priceRoot.querySelector(".price__regular .price-item--regular:not(.variant-item__old-price)") ||
      priceRoot.querySelector(".price__sale .price-item--sale.price-item--last") ||
      priceRoot.querySelector(".price-item");
    if (target) target.innerHTML = priceHtml;

    if (!priceRoot.querySelector(".drkalla-profi-inline-label")) {
      const label = document.createElement("span");
      label.className = "drkalla-profi-inline-label";
      label.textContent = "Profi-Preis";
      const container = priceRoot.querySelector(".price__container") || priceRoot;
      container.insertAdjacentElement("afterbegin", label);
    }
  }

  function formatCents(value) {
    const cents = Number(value);
    if (!Number.isFinite(cents) || cents <= 0) return "";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "de-DE", {
        style: "currency",
        currency: window.Shopify?.currency?.active || "EUR",
      }).format(cents / 100);
    } catch {
      return "";
    }
  }

  function updateProfiPricing(force) {
    const blocks = getProfiPriceBlocks();
    if (!blocks.length) return;
    fetchProfiStatus(force, getProfiProductIds(blocks), getProfiVariantIds(blocks)).then(applyProfiStatus);
  }

  function primeAccountComponentRefresh() {
    document.querySelectorAll("shopify-account").forEach((account) => {
      if (account.getAttribute("data-dk-profi-bound") === "true") return;
      account.setAttribute("data-dk-profi-bound", "true");
      account.addEventListener("click", () => {
        window.setTimeout(() => updateProfiPricing(true), 1800);
        window.setTimeout(() => updateProfiPricing(true), 5200);
      });
    });
  }

  function fitAboutVideoPoster() {
    document.querySelectorAll(".dk-about-page__media .deferred-media__poster img").forEach((image) => {
      image.style.width = "100%";
      image.style.height = "100%";
      image.style.objectFit = "contain";
      image.style.objectPosition = "center";
    });
  }

  function run() {
    classifyDialogs();
    updateProductGallerySticky();
    repairGermanPopupCopy();
    orderHomepageSections();
    repairHomepageShowcase();
    fitAboutVideoPoster();
    updateProfiPricing(false);
    primeAccountComponentRefresh();
  }

  function scheduleRun() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === "childList") {
        const addedNodes = Array.from(record.addedNodes || []);
        if (
          addedNodes.some(
            (node) =>
              node instanceof HTMLElement &&
              (node.matches(`${COOKIE_ROOT_SELECTOR}, .klaviyo-form, [class*="klaviyo"], [id*="klaviyo"], .samitaWS-container`) ||
                node.querySelector(`${COOKIE_ROOT_SELECTOR}, .klaviyo-form, [class*="klaviyo"], [id*="klaviyo"], .samitaWS-container`)),
          )
        ) {
          scheduleRun();
          return;
        }
      } else if (
        record.type === "characterData" &&
        record.target.parentElement?.closest(".samitaWS-container, .klaviyo-form, #shopify-pc__banner")
      ) {
        scheduleRun();
        return;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  const startedAt = Date.now();
  const repairTimer = window.setInterval(() => {
    run();
    if (Date.now() - startedAt > 12000) window.clearInterval(repairTimer);
  }, 600);
  window.addEventListener("scroll", scheduleRun, { passive: true });
  window.addEventListener("resize", scheduleRun, { passive: true });
  window.addEventListener("focus", () => updateProfiPricing(true));
  window.addEventListener("pageshow", () => updateProfiPricing(true));
})();
